import type { PagedQuery, PagedResult, TemplateDto } from "@mandoob/shared";

import {
  type QueryHookOptions,
  type RequestOptions,
  useApiQuery,
} from "@/api/query-helpers";
import { api } from "@/lib/api-client";

const BASE = "/api/templates";

export const getTemplates = (
  params?: PagedQuery,
  options?: RequestOptions,
  signal?: AbortSignal,
) =>
  api<PagedResult<TemplateDto>>(
    { url: BASE, method: "GET", params, signal },
    options,
  );

export const getGetTemplatesQueryKey = (params?: PagedQuery) =>
  [BASE, ...(params ? [params] : [])] as const;

export const useGetTemplates = (
  params?: PagedQuery,
  options?: QueryHookOptions<PagedResult<TemplateDto>>,
) =>
  useApiQuery(
    getGetTemplatesQueryKey(params),
    (request, signal) => getTemplates(params, request, signal),
    options,
  );
